import React from 'react';
import { useParams } from 'react-router-dom';
import useAsyncRetry from 'react-use/lib/useAsyncRetry';

import { Header } from '@internal/plugin-components-react';

import { useReleaseTagPageStyles } from './style';
import { useApi } from '@backstage/core-plugin-api';
import { deploymentManagementApiRef } from '../../api/types';
import ServicesVersionList from './ServicesVersionList';
import ReleaseTagForm from './ReleaseTagForm';

export function ReleaseTagPage() {
  const classes = useReleaseTagPageStyles();
  const deploymentManagementApi = useApi(deploymentManagementApiRef);
  const { releaseId } = useParams();
  const {
    value: releaseServiceVerions,
    loading: isFetchingReleaseServiceVerions,
    retry: refetchReleaseServiceVerions,
    error: errorFetchingReleaseServiceVerions,
  } = useAsyncRetry(
    async () =>
      deploymentManagementApi.getReleaseServiceVerions({
        releaseId: Number(releaseId),
      }),
    [releaseId],
  );

  return (
    React.createElement(React.Fragment, null
      , React.createElement(Header, {
        title: "Release History" ,
        breadcrumbItems: [
          {
            text: 'Release History',
            href: '/release-history',
          },
        ],}
      )
      , React.createElement('div', { className: classes.layoutWrapper,}
        , React.createElement('div', { className: classes.contentWrapper,}
          , releaseServiceVerions && (
            React.createElement(ReleaseTagForm, {
              releaseLabel: releaseServiceVerions.releaseLabel,
              tag: releaseServiceVerions.tag,}
            )
          )
          , React.createElement(ServicesVersionList, {
            currentServiceVersions: 
              releaseServiceVerions?.currentServiceVersions
            ,
            isFetchingReleaseServiceVerions: isFetchingReleaseServiceVerions,
            refetchReleaseServiceVerions: refetchReleaseServiceVerions,
            errorFetchingReleaseServiceVerions: 
              errorFetchingReleaseServiceVerions
            ,}
          )
        )
      )
    )
  );
}
